import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Filters} from '../../common/filters';
import {fetchListings} from '../../../actions/listings';
import {pushEdapEvent, getRefinements} from '../../../utils/edap';
import {UNREFINED_KEY} from '../../../utils/listings';

const MIN_SEGMENTS = 1;

function hasSegments({segments = []}) {
    return segments.length;
}

function getSegments(destination) {
    if (!hasSegments(destination)) {
        return null;
    }

    const unrefinedSegment = {
        name: 'Popular',
        messageKey: UNREFINED_KEY,
    };

    return destination.segments.length > MIN_SEGMENTS
        ? [unrefinedSegment, ...destination.segments]
        : null;
}

export function sendToEdap(refinementKey, position) {
    const mainData = {
        actionlocation: 'properties-module',
        eventrefinements: getRefinements({
            refinementKey,
            position,
            forceAddRefinementKey: true,
        }),
    };
    pushEdapEvent('refinement.click', mainData);
}

export function mapStateToProps({abacus, modules, destination}) {
    return {
        abacus,
        segments: getSegments(destination),
        segmentFilters: modules.segmentFilters,
        cachedListings: destination.cachedListings || {},
    };
}

export class SegmentFiltersComponent extends Component {
    static getDerivedStateFromProps(props, state) {
        const {overrideActive, filterOverride} = props;

        const {activeFilter} = state;

        if (overrideActive && filterOverride !== activeFilter) {
            return {
                activeFilter: filterOverride,
            };
        }

        return null;
    }

    constructor(props) {
        super(props);

        this.clickHandler = this.clickHandler.bind(this);

        this.state = {
            activeFilter: UNREFINED_KEY,
        };
    }

    clickHandler(segmentKey, position) {
        if (this.state.activeFilter === segmentKey) {
            return;
        }

        const {dispatch} = this.props;

        dispatch(fetchListings({segmentKey}));

        this.setState({
            activeFilter: segmentKey,
        });

        sendToEdap(segmentKey, position);
    }

    getButtonClasses(isActive) {
        return isActive ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-default';
    }

    render() {
        const {activeFilter} = this.state;

        const {segments, segmentFilters} = this.props;

        return segments ? (
            <div>
                <Filters>
                    {segments.map((segment, index) => (
                        <button
                            key={segment.messageKey}
                            className={this.getButtonClasses(
                                activeFilter === segment.messageKey
                            )}
                            onClick={this.clickHandler.bind(
                                null,
                                segment.messageKey,
                                index + 1
                            )} //eslint-disable-line
                        >
                            {segmentFilters[`${segment.messageKey}`]}
                        </button>
                    ))}
                </Filters>
            </div>
        ) : null;
    }
}

export const SegmentFilters = connect(mapStateToProps)(SegmentFiltersComponent);

SegmentFilters.displayName = 'SegmentFilters';

export default SegmentFilters;
